import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, isRef as _isRef } from "vue"

import MyDialog from "~/cabinet/vue/interface/dialog/MyDialog.vue";
import {__} from "~/ts/library/Translate";
import {TAB_TYPE_FORM, TAB_TYPE_HTML, TAB_TYPE_PAYMENT} from "~/chat/ts/data/ITab";
import {computed, ref} from "vue";
import {
    getSendTabShowTypes, sendTab,
    SHOW_TAB_TYPE_SHOW, ShowTypeId
} from "~/operatorApplication/ts/service/dialog/OperatorApplicationSendTab";


const __default__ = {
    name: "OperatorApplicationSendTabDialog"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    tabTypeId: {},
    tabs: {},
    client: {}
  }, {
    "visible": { type: Boolean },
    "visibleModifiers": {},
  }),
  emits: ["update:visible"],
  setup(__props: any) {

let props = __props

let isVisible = _useModel<boolean>(__props, "visible");
function close() {
    isVisible.value = false;
}

let model = ref<{
    tabId: string,
    paymentSumTypeId: string,
    paymentSum: number,
    paymentComment: string,
    showType: ShowTypeId
}>({
    tabId: props.tabs[0].id,
    paymentSumTypeId: null,
    paymentSum: 1000,
    paymentComment: null,
    showType: SHOW_TAB_TYPE_SHOW
});

let isPayment = computed(() => {
    return props.tabTypeId === TAB_TYPE_PAYMENT;
});

let title = computed(() => {
    if (props.tabTypeId === TAB_TYPE_PAYMENT) {
        return __("Выставление счёта");
    } else if (props.tabTypeId === TAB_TYPE_FORM) {
        return __("Отправка формы сбора данных");
    } else if (props.tabTypeId === TAB_TYPE_HTML) {
        return __("Отправка информационной вкладки");
    } else {
        return __("Отправка вкладки");
    }
});

let selectedTitle = computed(() => {
    if (props.tabTypeId === TAB_TYPE_PAYMENT) {
        return __("Выбранная форма оплаты");
    } else if (props.tabTypeId === TAB_TYPE_FORM) {
        return __("Выбранная форма сбора данных");
    } else if (props.tabTypeId === TAB_TYPE_HTML) {
        return __("Выбранная информационная вкладка");
    } else {
        return __("Выбранная вкладка");
    }
});

let selectedTab = computed(() => {
    let tab = props.tabs.find(tab => tab.id == model.value.tabId);
    if (tab) {
        let types = tab.paymentSumTypes;
        if (types && types.length) {
            model.value.paymentSumTypeId = types[0].id;
        }
    }
    return tab;
});

let selectedPaymentFormSumType = computed(() => {
    return selectedTab.value.paymentSumTypes?.find(type => type.id == model.value.paymentSumTypeId);
});

async function onApply() {

    let modelValue = model.value;
    let additionalParams: Partial<OperatorApplicationApi.OperatorMessageSendTabOpenApiModel> = {};

    if (modelValue.paymentComment) {
        additionalParams.paymentComment = modelValue.paymentComment;
    }
    if (modelValue.paymentSumTypeId) {
        additionalParams.paymentSumTypeId = modelValue.paymentSumTypeId;
    }
    if (modelValue.paymentSum) {
        additionalParams.paymentSum = modelValue.paymentSum;
    }
    let result = await sendTab(props.client.username, modelValue.tabId, modelValue.showType, additionalParams);
    if (!result.showMessageOnError()) {
        close();
    }
}



return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createBlock(MyDialog, {
    visible: _unref(isVisible),
    "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => (_isRef(isVisible) ? (isVisible).value = $event : isVisible = $event)),
    title: _unref(title),
    form: {model: _unref(model), labelPosition: 'top'},
    "close-on-press-escape": "",
    onApply: onApply
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form_item, { label: _unref(selectedTitle) }, {
        default: _withCtx(() => [
          _createVNode(_component_el_select, {
            modelValue: _unref(model).tabId,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(model).tabId) = $event)),
            class: "w-100"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, (tab) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: tab.id,
                  label: tab.descr,
                  value: tab.id
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["label"]),
      (_unref(selectedTab) && _unref(selectedTab).paymentSumTypes && _unref(selectedTab).paymentSumTypes.length)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_el_form_item, {
              label: _unref(__)('Сумма оплаты:')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(model).paymentSumTypeId,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(model).paymentSumTypeId) = $event)),
                  class: "w-100"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectedTab).paymentSumTypes, (type) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: type.id,
                        label: type.descr,
                        value: type.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            (_unref(selectedPaymentFormSumType) && _unref(selectedPaymentFormSumType).isOperatorMustProvideSum)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: _unref(__)('Введите сумму:')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "number",
                      modelValue: _unref(model).paymentSum,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(model).paymentSum) = $event)),
                      modelModifiers: { number: true }
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true),
      (_unref(isPayment))
        ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 1,
            label: `${_unref(__)('Дополнительная информация:')}`
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "textarea",
                modelValue: _unref(model).paymentComment,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(model).paymentComment) = $event)),
                autosize: {minRows:1, maxRows:10},
                placeholder: _unref(__)('Будет видна клиенту и в отчетах')
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]))
        : _createCommentVNode("", true),
      (!__props.client.integration)
        ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 2,
            label: _unref(__)('Способ отображения')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _unref(model).showType,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(model).showType) = $event)),
                class: "w-100"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getSendTabShowTypes)(), (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      value: item.id,
                      label: item.descr
                    }, null, 8, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "title", "form"]))
}
}

})